import React, { useState } from 'react'
import PropTypes from 'prop-types'
import Menu from '@mui/material/Menu'
import MenuItem from '@mui/material/MenuItem'
import NewWindowIcon from '@mui/icons-material/OpenInNew'
import DropdownArrowIcon from '@mui/icons-material/ArrowDropDown'
import StyledLink from '../StyledLink'

// eslint-disable-next-line react/prop-types
function MenuItemLink({ link, text }) {
  return (
    <StyledLink
      to={link}
      external
      newWindow
      styles={{ color: '#222' }}
      disableUnderline
      contents={(
        <MenuItem style={{ fontSize: '14px' }}>
          {text}
          <NewWindowIcon style={{
            width: '16px', height: '16px', marginLeft: '5px', verticalAlign: 'middle',
          }}
          />
        </MenuItem>
 )}
    />
  )
}

export function DomainInfoPopover({ email, domainName }) {
  const [anchorEl, setAnchorEl] = useState(null)

  const onClick = (event) => {
    setAnchorEl(event.currentTarget)
  }
  const handleRequestClose = () => {
    setAnchorEl(null)
  }

  return (
    <div style={{ display: 'inline-block' }}>
      <button
        type="button"
        onClick={(e) => onClick(e)}
        style={{
          background: 'transparent', border: 'none', fontSize: 'inherit', cursor: 'pointer',
        }}
      >
        {email}
        <DropdownArrowIcon style={{ position: 'relative', top: '-1px', verticalAlign: 'middle' }} />
      </button>

      <Menu open={Boolean(anchorEl)} anchorEl={anchorEl} onClose={handleRequestClose}>
        <MenuItemLink link={`http://www.${domainName}`} text="View domain" />
        <MenuItemLink link={`https://www.google.com/search?q=www.${domainName}`} text="Search Google" />
        <MenuItemLink link={`http://www.whois.com/whois/${domainName}`} text="View WHOIS" />
      </Menu>

    </div>
  )
}

DomainInfoPopover.propTypes = {
  email: PropTypes.string.isRequired,
  domainName: PropTypes.string.isRequired,
}

export default DomainInfoPopover
